/**
 * Deze klasse handelt het aanpassen van een image log af
 *
 * @history
 * 26 november 2022
 * Start implementatie
 *
 */

import React from "react";
import {Popup} from "../../containers/Popup";

export class LogImageForm extends React.Component {
    constructor(props) {
        super(props);

        this.state =
            {
                show_err: false,
                err_message: ""
            }


        this.inputTitle = React.createRef();
        this.inputText = React.createRef();

        this.storeClicked = this.storeClicked.bind(this);
        this.terugClicked = this.terugClicked.bind(this);
        this.inputImageBtn = React.createRef();
        this.imagePreview = React.createRef();
        this.imageSelectClicked = this.imageSelectClicked.bind(this);
        this.imageSelected = this.imageSelected.bind(this);

        this.image_data = "";

        this.formData = new FormData();

        this.formData.append("group_id", this.props.group_id);
        this.formData.append("access_id1",window.app.logboek.access_id1);
        this.formData.append("access_id2",window.app.logboek.access_id2);
        this.formData.append("kind","image");
        this.formData.append("location_id", this.props.location_id);

        if (this.props.action == "add")
        {
            this.form_url = "/add_log";
            this.props.log.title ="";
            this.props.log.data = "";
        }
        else
        {
            this.form_url ="/store_log";
            this.formData.append("id", this.props.log.id);
        }

    }

    imageSelectClicked() {
        this.inputImageBtn.current.click();
    }

    imageSelected(event) {

        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj) {
            console.log("no file")
            return;
        }


        var reader = new FileReader();
        const _this = this;
        reader.onload = function (e) {
            _this.imagePreview.current.src = e.target.result;
            _this.image_data = e.target.result;
            _this.imagePreview.current.style.display = 'block';
        };
        reader.readAsDataURL(fileObj);
    }


    terugClicked()
    {
        this.props.edit_done_callback(false);
    }

    storeClicked()
    {
        if (this.image_data == "" && this.props.action == "add")
        {
            this.setState({"show_err":true, "err_message":"Geen afbeelding geselecteerd. Probeer het opnieuw"});
            return false;
        }

        this.setState({"show_err":false});


        this.setState({"show_err":false});
        this.formData.append("title", this.inputTitle.current.value);
        this.formData.append("text", this.inputText.current.value);

        if (this.image_data != "") {
            var img = document.createElement("img");
            img.src = this.image_data;
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            // Set Width and Height

            var width = img.width;
            var height = img.height;
            if (width > height) {
                if (width > 500) {
                    height *= 500 / width;
                    width = 500;
                }
            } else {
                if (height > 500) {
                    width *= 500 / height;
                    height = 500;
                }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);
            this.formData.append("image", canvas.toDataURL("image/jpeg", 1)); // 100% kwaliteit
        }



        const requestOptions = {
            method: 'POST',
            body: this.formData
        };

        fetch(this.form_url, requestOptions)
            .then(response => response.json())
            .then(log_json =>
            {
                if (log_json.status == "err")
                {
                    this.setState({"show_err":true, "err_message":"opslaan niet gelukt. Probeer het opnieuw"});

                }
                else
                {
                    this.setState({'login_err':false});
                    this.props.edit_done_callback(true, log_json.data);
                }
            });
    }


    render() {
        return (
        <Popup has_close_btn={false} title={""}>

                    <h2>Titel</h2>
                    <input type={"text"} className={"logger__input"} name={"title"}  ref={this.inputTitle} defaultValue={this.props.log.title}/><br/>

            <input type="file" accept="image/*;capture=camera" id="upload_image" name={"image"}
                   ref={this.inputImageBtn}
                   style={{"display": "none"}} onChange={this.imageSelected}
            />



            {(this.props.action == "add" ) && (
                <>
                <img id="upload_image_preview"
                     style={{"width": "50%", "height": "auto", "margin-top": "5px", "display": " none"}}
                     ref={this.imagePreview}/>
                <a href="javascript:void(0);" onClick={this.imageSelectClicked} className={"button"}
                id="upload_image_btn">Kies afbeelding</a>
                </>
            )}
            {(this.props.action == "edit" ) && (
                <>
                <img id="upload_image_preview" src={this.props.log.image_url}
                     style={{"width": "50%", "height": "auto", "margin-top": "5px"}}
                     ref={this.imagePreview}/>
                    <a href="javascript:void(0);" onClick={this.imageSelectClicked} className={"button"}
                       id="upload_image_btn">Vervang afbeelding</a>
                </>
            )}


            <br clear="all"/>




                    <h2>Beschrijving</h2>
                    <textarea  className={"logger__textarea"} name={"description"}  ref={this.inputText}>{this.props.log.data}</textarea><br/>
                    <a href="javascript:void(0)" className={"button"} onClick={this.terugClicked}>Terug</a>
                    <a href="javascript:void(0)" className={"button"} onClick={this.storeClicked}>Opslaan</a>


                {this.state.show_err && (
                    <div style={{"float":"left","width":"100%","color":"#F00"}}>
                        <p>{this.state.err_message}</p>
                    </div>
                )}
          </Popup>

        );
    }

}
